// extracted by mini-css-extract-plugin
export default {"collapsibleContent":"sFlo5t9DzjjdlQaC23Qk"};